import { LOGIN_TOKEN } from '@/global/constants'
import { localCache } from '@/utils/cache'
import { TIME_OUT } from './config'
import HYRequest from './request'
import { HYRequestTwo } from './request'
const hyRequest = new HYRequest({
  baseURL: BASE_URL,
  timeout: TIME_OUT,
  interceptors: {
    requestSuccessFn: (config) => {
      // 每一个请求都自动携带token
      const token = localCache.getCache(LOGIN_TOKEN)
      if (config.headers && token) {
        // 类型缩小
        config.headers['sts-token'] = token
      }
      return config
    }
  }
})

export default hyRequest
export const hyRequestTwo = new HYRequestTwo({
  baseURL: BASE_URL,
  timeout: TIME_OUT,
  interceptors: {
    requestSuccessFn: (config) => {
      // 每一个请求都自动携带token
      const token = localCache.getCache(LOGIN_TOKEN)
      if (config.headers && token) {
        // 类型缩小
        config.headers['sts-token'] = token
      }
      return config
    }
  }
})

export const hyRequestStar = new HYRequest({
  // baseURL: BASE_URL_STAR,
  baseURL: '',
  timeout: TIME_OUT,
  interceptors: {
    requestSuccessFn: (config) => {
      // 每一个请求都自动携带token
      const token = localCache.getCache(LOGIN_TOKEN)
      if (config.headers && token) {
        // 类型缩小
        config.headers['ta-jwt'] = token
      }
      return config
    }
  }
})
